import { UploadsService } from './../uploads/uploads.service';
import { Component, Inject, OnInit } from '@angular/core';
import { PersonalInfoService } from './../personal-info/personal-info.service';
import { WorkExperienceService } from './../work-experience/work-experience.service';
import { RefereeService } from './../referee/referee.service';
import { EducationalInfo } from './../educational-info/educationalInfo';
import { EducationalInfoService } from './../educational-info/educational-info.service';
import Swal from 'sweetalert2';
import { repeat } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareUrlService } from '../../_services/share-url.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { IJobTitle } from '../work-experience/jobTitle';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  educationalInfo;
  referees;
  experiences;
  personalInfo;
  eduID;
  refereeID;
  experienceID;
  personalID;
  uploadID;
  uploads;
  payload;
  educationTypes;
  industrySectors
  payloadList = [];
  load = {};

  showEnglishAndMaths = false;
  selectedType = "";
  aLevel = false;

  ordinaryLevel = "O'Level";
  advancedLevel = "A'Level";

  showPersonalInfo = false;
  showExperience = false;
  showEducation = false;
  showReferee = false;
  showUploads = false;

  present
  presentJob
  profileImage;
  jobCategories;
  jobsTitle: IJobTitle[] = Array();

  public allowedExtensions = ['jpeg', 'png', 'jpg'];
  public uploading: boolean;
  public imagePicked: boolean;
  public maxFileSizeReached: boolean;
  public futureDate: boolean;
  public todayDate: Date;

  uploadFileForm = new FormGroup({
    file: new FormControl('', [Validators.required]),
    fileSource: new FormControl('', [Validators.required])
  });


  constructor(private educationalInfoService: EducationalInfoService,
    private refereeService: RefereeService,
    private workExperienceService: WorkExperienceService,
    private personalInfoService: PersonalInfoService,
    private uploadsService: UploadsService,
    private router: Router,
    @Inject(DOCUMENT) private _document: Document,
    private shareUrlService: ShareUrlService) { }

  ngOnInit(): void {
    this.getEducationalInfo();
    this.getReferees();
    this.getExperiences();
    this.getPersonalInfo();
    this.getUploads();
    this.getEducationTypes();
    this.getIndustrySector();
    this.getProfileImage();
    this.getJobTitleCategories();
    this.showEnglishAndMaths;
    this.aLevel;
    this.ordinaryLevel;
    this.advancedLevel;
    this.futureDate
    this.todayDate = new Date()
  }

  checkIfDateIsLessThanCurrentDate(dateGet) {
    // Date dateNow = new Date();
    let dateTime = new Date()


    console.log("====================== dateTime :: ", dateTime)
    console.log("====================== date input :: ", dateGet)

    let newDate = new Date(dateGet)
    console.log("====================== newDate :: ", newDate)
    let newDate2 = new Date('1993-03-10')
    console.log("====================== newDate2 :: ", newDate2)
    if (newDate > dateTime) {
      this.futureDate = true
      console.log("====================== greater than curren date :: ")
    } else {
      this.futureDate = false
      console.log("====================== less than curren date :: ")
    }

  }

  onCurrentJobChange(data) {
    if (this.present === false) {
      this.present = true;
      this.presentJob = false;
    } else {
      this.present = false;
      this.presentJob = true;
    }
  }

  clickCancelEdit() {
    this.eduID = 0;
    this.refereeID = 0;
    this.experienceID = 0;
    this.personalID = 0;
    this.uploadID = 0;
  }

  clickEducationEdit(id, theEducationType) {
    this.eduID = id;
    this.refereeID = 0;
    this.experienceID = 0;
    this.personalID = 0;
    this.uploadID = 0;
    this.getEducationTypes();
    this.onChange(theEducationType);
  }

  clickRefereeEdit(id) {
    this.refereeID = id;
    this.eduID = 0;
    this.experienceID = 0;
    this.personalID = 0;
    this.uploadID = 0;
  }

  clickExperienceEdit(id, present) {
    this.experienceID = id;
    this.eduID = 0;
    this.refereeID = 0;
    this.personalID = 0;
    this.uploadID = 0;
    this.present = present;
    this.getIndustrySector();
  }

  clickPersonalInfoEdit(id) {
    this.personalID = id;
    this.eduID = 0;
    this.refereeID = 0;
    this.experienceID = 0;
    this.uploadID = 0;
  }

  clickUploadEdit(id) {
    this.personalID = 0;
    this.eduID = 0;
    this.refereeID = 0;
    this.experienceID = 0;
    this.uploadID = id;
  }

  onChange(educationType) {
    this.selectedType = educationType;
    if (educationType.match("O'Level")) {
      this.showEnglishAndMaths = true;
      this.aLevel = false;
    } else if (educationType.match("A'Level")) {
      this.showEnglishAndMaths = false;
      this.aLevel = true;
    } else {
      this.showEnglishAndMaths = false;
      this.aLevel = false;
    }
  }

  getProfileImage() {
    this.uploadsService.getProfileImage().subscribe(response => {
      this.profileImage = response.url;
    });
  }

  getJobTitleCategories() {
    this.workExperienceService.getJobCategoriesList()
      .subscribe(response => {
        this.jobCategories = response['JobTitleCategory']
        this.jobsTitle = response['JobTitleCategory']
      })
  }

  onFileChange(event) {

    console.log('File size: ' + event.target.files[0].size);
    console.log('File type: ' + event.target.files[0].type);
    console.log('File name: ' + event.target.files[0].name);
    console.log('File : ' + event.target.files[0]);
    console.log('File target : ' + event.target);

    this.validateFileSize(event.target.files[0].size);

    if (this.validateFileSize(event.target.files[0].size)) {

      if (event.target.files.length > 0) {
        console.log("FILE :: UPLOADING NOW ")
        const file = event.target.files[0];
        this.uploadFileForm.patchValue({
          fileSource: file
        });
        const formData = new FormData();
        formData.append('file', this.uploadFileForm.get('fileSource').value);

        this.uploadsService.uploadProfileImage(formData)
          .subscribe(res => {

            if (res['status'] === "success") {
              this.profileImage = res['profile']['url']
              console.log("============ URL :: ", this.profileImage)
              Swal.fire(
                'Done!',
                'Your Profile image was successfully saved!',
                'success'
              ).then((result) => {
                if (result.value) {
                  this._document.defaultView.location.reload();
                }
              });
              console.log(res);

            } else if (res['status'] === "failed") {
              Swal.fire(
                'Failed!',
                res['message'],
                'error'
              );
            } else {
              Swal.fire(
                'Failed!',
                'Something went wrong!',
                'error'
              );
            }
          });
      }


    }
    else {
      Swal.fire(
        'Failed!',
        'Image has exceeded the allowed maximum file size of 3MB!',
        'error'
      );
    }




  }

  validateFileType(name: string) {
    const ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() === 'png' || ext.toLowerCase() === 'jpg' || ext.toLowerCase() === 'jpeg') {
      this.imagePicked = true;
      return true;
    } else {
      this.imagePicked = false;
      return false;
    }
  }

  validateFileSize(size: number) {
    console.log("============  FILE SIZE :: ", size)
    console.log("============  FILE SIZE : (size / (1024 * 1024)) > 3 :: ", (size / (1024 * 1024)))
    console.log("============  FILE SIZE : ", Math.round(size / (1024 * 1024)) > 3)
    if (Math.round(size / (1024 * 1024)) > 3) {
      this.maxFileSizeReached = true;
      return false;
    } else {
      this.maxFileSizeReached = false;
      return true;
    }
  }

  getEducationTypes() {
    this.educationalInfoService.getEducationalTypes().subscribe(response => {
      this.educationTypes = response;
    });
  }

  getIndustrySector() {
    this.workExperienceService.getIndustrySectors().subscribe(response => {
      this.industrySectors = response;
    })
  }

  getEducationalInfo() {
    this.educationalInfoService.getEducationInfomation()
      .subscribe(response => {
        this.educationalInfo = response;
        if (response.length === 0)
          this.showEducation = false;
        else
          this.showEducation = true
      });
  }

  updateEducation(id, data) {
    data.id = id;
    this.educationalInfoService.updateEducationInfo(data)
      .subscribe(response => {
        if (response.id !== null) {
          Swal.fire(
            'Done!',
            'Educational info updated!',
            'success'
          );
        }
        this.eduID = 0;
        this.getEducationalInfo();
      });
  }

  deleteEducation(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to restore this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {
        this.educationalInfoService.deleteEducationInfo(id)
          .subscribe(response => {
            if (response.id !== null) {
              Swal.fire(
                'Done!',
                'Educational info deleted!',
                'success'
              );
            }
            this.eduID = 0;
            this.getEducationalInfo();
          });
      }
    });
  }

  getReferees() {
    this.refereeService.getReferees()
      .subscribe(response => {
        this.referees = response;
        if (response.length === 0)
          this.showReferee = false;
        else
          this.showReferee = true
      });
  }

  updateReferee(id, data) {
    data.id = id;
    this.payloadList = [data];
    this.refereeService.updateReferee(this.payloadList)
      .subscribe(response => {
        if (response.id !== null) {
          Swal.fire(
            'Done!',
            'Educational info updated!',
            'success'
          );
        }
        this.refereeID = 0;
        this.getReferees();
      });
  }

  deleteReferee(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to restore this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {
        this.refereeService.deleteReferee(id)
          .subscribe(response => {
            if (response.id !== null) {
              Swal.fire(
                'Done!',
                'Referee deleted!',
                'success'
              );
            }
            this.refereeID = 0;
            this.getReferees();
          });
      }
    });
  }

  getExperiences() {
    this.workExperienceService.getExperience()
      .subscribe(response => {
        this.experiences = response;

        console.log("============== exp : " + this.experiences)
        if (response.length === 0)
          this.showExperience = false;
        else
          this.showExperience = true
      });
  }

  updateExperience(id, data) {
    data.id = id;
    this.workExperienceService.updateExperience(data)
      .subscribe(response => {
        if (response.id !== null) {
          Swal.fire(
            'Done!',
            'Working Experience is updated!',
            'success'
          );
        }
        this.experienceID = 0;
        this.getExperiences();
      });
  }

  deleteExperience(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to restore this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {
        this.workExperienceService.deleteExperience(id)
          .subscribe(response => {
            if (response.id !== null) {
              Swal.fire(
                'Done!',
                'Work Experience is deleted!',
                'success'
              );
            }
            this.experienceID = 0;
            this.getExperiences();
          });
      }
    });
  }

  getPersonalInfo() {
    this.personalInfoService.getPersonalInfo()
      .subscribe(response => {
        this.personalInfo = response;
        console.error("=========== personal info >> ", response)
        if (response === null)
          this.showPersonalInfo = false;
        else
          this.showPersonalInfo = true
      });
  }

  updatePersonalInfo(id, data) {
    data.id = id;
    this.personalInfoService.updatePersonalInfo(data)
      .subscribe(response => {
        if (response.id !== null) {
          Swal.fire(
            'Done!',
            'Personal Info is updated!',
            'success'
          );
        }
        this.personalID = 0;
        this.getPersonalInfo();
      });
  }

  getUploads() {
    this.uploadsService.getUploads()
      .subscribe(response => {
        this.uploads = response;
        if (response.length === 0)
          this.showUploads = false;
        else
          this.showUploads = true
      });
  }

  deleteUpload(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to restore this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete!',
      showLoaderOnConfirm: true
    }).then((result) => {
      if (result.value) {
        this.uploadsService.deleteUpload(id)
          .subscribe(response => {
            console.warn('============ repsonde delete ', response);
            if (response.status == 'success') {
              Swal.fire(
                'Deleted!',
                'Upload has been deleted.',
                'success'
              );
              this.uploadID = 0;
              this.getUploads();
            }
          });
      }
    });
  }

  viewUpload(url) {
    this.shareUrlService.changeMessage(url);
    this.router.navigate(['dashboard/view-pdf']);
  }

}
